import { render, staticRenderFns } from "./Kb2.vue?vue&type=template&id=3d0032d8&scoped=true&"
import script from "./Kb2.vue?vue&type=script&lang=js&"
export * from "./Kb2.vue?vue&type=script&lang=js&"
import style0 from "./Kb2.vue?vue&type=style&index=0&id=3d0032d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0032d8",
  null
  
)

export default component.exports